import { render, staticRenderFns } from "./TaxonomyTagList.vue?vue&type=template&id=6d798da0&scoped=true&"
import script from "./TaxonomyTagList.vue?vue&type=script&lang=js&"
export * from "./TaxonomyTagList.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyTagList.vue?vue&type=style&index=0&id=6d798da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d798da0",
  null
  
)

export default component.exports